import { useEffect, useRef } from "react";

interface AdminScrollTarget {
  scrollIntoView(options: { behavior: "auto"; block: "start"; inline: "nearest" }): void;
}
interface AdminFocusTarget {
  focus(options: { preventScroll: true }): void;
}

export function scrollAndFocusAdminDetail(container: AdminScrollTarget, heading: AdminFocusTarget) {
  container.scrollIntoView({ behavior: "auto", block: "start", inline: "nearest" });
  heading.focus({ preventScroll: true });
}

export function useAdminDetailFocus(key: string) {
  const containerRef = useRef<HTMLElement & AdminScrollTarget>(null);
  const headingRef = useRef<HTMLHeadingElement & AdminFocusTarget>(null);
  useEffect(() => {
    if (containerRef.current && headingRef.current) {
      scrollAndFocusAdminDetail(containerRef.current, headingRef.current);
    }
  }, [key]);
  return { containerRef, headingRef };
}